export const OPEN_VIEW_PAYLOAD_MODAL='OPEN_VIEW_PAYLOAD_MODAL';
export const CLOSE_VIEW_PAYLOAD_MODAL='CLOSE_VIEW_PAYLOAD_MODAL';
export const SET_DATA_VIEW_PAYLOAD='SET_DATA_VIEW_PAYLOAD';
